import React, { forwardRef } from "react";
import { FloatingLabel, Form } from "react-bootstrap";

export const FloatingField = forwardRef((props, ref) => {
  const {
    error,
    label,
    focus,
    labelClass,
    errorClass = "",
    controlId,
    id,
    ...rest
  } = props;

  // Single id for label htmlFor + context; do not pass id on Form.Control (RB dev warning).
  const inputId = id ?? controlId;

  const invalid = !!(error);
  const valid = !!(focus && !error);

  return (
    <FloatingLabel
      controlId={inputId}
      label={label}
      className={`${labelClass || ""} _inInput_fx`}
    >
      <Form.Control
        ref={ref}
        autoComplete="off"
        type={rest.type || "text"} // default type
        isInvalid={invalid}
        isValid={valid}
        aria-invalid={invalid}
        aria-describedby={
          invalid ? `${inputId}-error` : valid ? `${inputId}-success` : undefined
        }
        {...rest}
      />

      {invalid && (
        <p
          id={`${inputId}-error`}
          className={`${errorClass} invalid-feedback d-block`}
        >
          {error}
        </p>
      )}
    </FloatingLabel>
  );
});
